<h3 mat-dialog-title>Filtrar Usuário</h3>
<div mat-dialog-content style="width: 100%">
    <div fxLayout="row wrap" *ngIf="exibeRoles">
        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="1000">
                <mat-label>Perfil</mat-label>
                <mat-select placeholder="Perfil" [formControl]="role_id" name="role_id">
                    <mat-option value="">Selecione...</mat-option>
                    <mat-option *ngFor="let role of listRoles" [value]="role.id">{{role.name}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingRoleSpinner"></mat-spinner>
            </mat-form-field>
        </div>
    </div>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="1000">
                <mat-label>Escritório</mat-label>
                <mat-select placeholder="Escritório" [formControl]="escritorio_id" style="width: 100%">
                    <mat-option value="">Selecione...</mat-option>
                    <mat-option *ngFor="let escritorio of listEscritorios"
                        [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingEscritorioSpinner"></mat-spinner>
            </mat-form-field>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Nome</mat-label>
            <input matInput placeholder="Ex: Carlos Alberto" [formControl]="name" maxlength="255">
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Filtrar</button>
</div>